module.exports = __webpack_public_path__ + "dingbeauty-landing/img/icon_client.c2914687.svg";